import { useTranslation } from 'react-i18next';

export function Guide() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.Omnichat.guide',
  });
  return (
    <div className="space-y-4 rounded-lg bg-gray-100 p-4">
      <h3 className="mb-2 text-lg font-semibold">{t('title')}</h3>

      <div className="space-y-2">
        <h4 className="mb-2 font-semibold">{t('stepTitle')} </h4>

        <ol className="list-inside list-decimal space-y-2 pl-4">
          <li>{t('steps.step1')}</li>
          <li>{t('steps.step2')}</li>
          <li>{t('steps.step3')}</li>
          <li>{t('steps.step4')}</li>
          <li>{t('steps.step5')}</li>
          <li>{t('steps.step6')}</li>
        </ol>
      </div>
    </div>
  );
}
